<div class="sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div
    *ngIf="!is_evaluation_read_running"
    class="sp-padding__x2">
    <h2>Process ID: {{ decido_evaluation.process_id }}</h2>
    <pre> {{ decido_evaluation | json }} </pre>
  </div>

  <div
    *ngIf="is_evaluation_read_running"
    class="sp-column__center sp-width__full sp-padding__x2">
    <mat-spinner
      color="accent"
      diameter="40"></mat-spinner>
    <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
  </div>
</div>
